import { createBrowserRouter, Navigate } from 'react-router-dom';
import AppLayout from './AppLayout';
import { RootRedirect } from './navigation/RootRedirect';
import {
  AppErrorPage,
  LogoutPage,
  NotFoundPage,
  RouteErrorPage,
} from '../pages';
import DashboardLandingPage from '../features/dashboard';
import LocationScheduleHealthPage from '../features/reports-location-health';
import DependencyBlockersPage from '../features/reports-dependency-blockers';
import SCurvePage from '../features/reports-s-curve';
import ImportPlanningPage from '../features/schedule-import';
import LocationManagementPage from '../features/schedule-locations';
import GanttPage from '../features/schedule-tasks';
import BaselinesPage from '../features/schedule-baselines';
import CalendarPage from '../features/schedule-calendar';
import ResourceManagementPage from '../features/schedule-resources';
import { RequestTrackingPage } from '../features/request-tracking';
import { APP_ROUTES } from '../navigation/appRoutes';

export const appRouter = createBrowserRouter([
  {
    path: APP_ROUTES.error,
    element: <AppErrorPage />,
    errorElement: <RouteErrorPage />,
  },
  {
    path: APP_ROUTES.logout,
    element: <LogoutPage />,
  },
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <RouteErrorPage />,
    children: [
      { index: true, element: <RootRedirect /> },

      { path: 'dashboard/overview', element: <DashboardLandingPage /> },
      {
        path: 'dashboard/reports',
        element: <Navigate to={APP_ROUTES.reports.locationHealth} replace />,
      },
      {
        path: 'dashboard',
        element: <Navigate to={APP_ROUTES.dashboard.overview} replace />,
      },

      { path: 'reports/location-health', element: <LocationScheduleHealthPage /> },
      { path: 'reports/dependency-blockers', element: <DependencyBlockersPage /> },
      { path: 'reports/s-curve', element: <SCurvePage /> },
      {
        path: 'reports',
        element: <Navigate to={APP_ROUTES.reports.locationHealth} replace />,
      },

      { path: 'schedule/import', element: <ImportPlanningPage /> },
      { path: 'schedule/locations', element: <LocationManagementPage /> },
      { path: 'schedule/tasks', element: <GanttPage /> },
      { path: 'schedule/baselines', element: <BaselinesPage /> },
      { path: 'schedule/calendar', element: <CalendarPage /> },
      { path: 'schedule/resources', element: <ResourceManagementPage /> },
      {
        path: 'schedule',
        element: <Navigate to={APP_ROUTES.schedule.import} replace />,
      },

      { path: 'request-tracking', element: <RequestTrackingPage /> },

      // Legacy paths → canonical routes
      { path: 'gantt', element: <Navigate to={APP_ROUTES.schedule.tasks} replace /> },
      { path: 'tasks', element: <Navigate to={APP_ROUTES.schedule.import} replace /> },
      { path: 'calendar', element: <Navigate to={APP_ROUTES.schedule.calendar} replace /> },
      {
        path: 'location-management',
        element: <Navigate to={APP_ROUTES.schedule.locations} replace />,
      },
      {
        path: 'import-planning',
        element: <Navigate to={APP_ROUTES.schedule.import} replace />,
      },

      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
